export const getWaitingRoomMarkdown = (
  slideDeckName: string,
  slideDeckTeaser: string
) => `<div style="display: flex; gap: 4em; align-items: center;">

<div style="flex: 1;">

<img src="/assets/images/logo.png" alt="Breakout Learning" style="width: 3.75em;" />

## Welcome to your Breakout Room.

When you're ready, advance to the next slide to begin the experience.

</div>

<div style="padding:1em 1.5em; border-radius:0.75em; max-width:350px; box-shadow: 0 0.5em 1em rgba(0,0,0,0.15); flex-shrink: 0; text-align: center; display: flex; flex-direction: column; gap: 0.25em;">

We hope you enjoy


### **${slideDeckName}**
_${slideDeckTeaser}_


Sincerely,
The Breakout Learning Team

</div>

</div>`
